"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var approvalRouter = {
  path: '/approval',
  component: _layout.default,
  redirect: '/approval/myApproval',
  name: 'Approval',
  meta: {
    title: '我的审批',
    icon: 'clipboard'
  },
  children: [{
    path: 'myApproval',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/approval/myApproval'));
      });
    },
    name: 'MyApproval',
    meta: {
      title: '我发起的审批',
      icon: ''
    }
  }, {
    path: 'myCc',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/approval/myCc'));
      });
    },
    name: 'MyCc',
    meta: {
      title: '我收到的抄送',
      icon: ''
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/approval/approvalDetail'));
      });
    },
    name: 'ApprovalDetail',
    hidden: true,
    meta: {
      title: '审批详情',
      activeMenu: '/approval/myApproval'
    }
  }]
};
var _default = exports.default = approvalRouter;